export default __webpack_public_path__ + "static/media/Felix Grimm .41c690cb.jpg";